export const ASSIGN_SCOREBOARD_TYPE_ID = 'scoreboards/ASSIGN_SCOREBOARD_TYPE_ID'
export const ASSIGN_API_POLLING_TIME_INTERVAL = 'scoreboards/ASSIGN_API_POLLING_TIME_INTERVAL'
export const ASSIGN_CONTROL_ID = 'scoreboards/ASSIGN_CONTROL_ID'
